/**
 * A belépett global admin írás- és belépés-kérése. Az axios (elutasított írás) és a képernyők innen kérik,
 * a gyökérben ülő `tenant-access-prompt` ablak válaszol: igaz, ha a hozzáférés megvan, hamis, ha a felhasználó
 * elvetette. Egyszerre egy kérés fut: a közben elutasított további írások ugyanarra a válaszra várnak.
 */
let handler = null;
let pending = null;

export function registerTenantAccessPrompt(fn) {
    handler = fn;
}

function ask(request) {
    if (!handler) {
        return Promise.resolve(false);
    }

    if (!pending) {
        pending = Promise.resolve(handler(request)).finally(() => {
            pending = null;
        });
    }

    return pending;
}

/** Írás bekapcsolása a belépett intézményben (indok, időkorlát). */
export function requestWriteAccess() {
    return ask({type: 'write'});
}

const LINK_KEY = 'tenantEntryLink';

/** A `?tenant=` link megjegyzése a router-őrben (a jog-ellenőrzés előtt), hogy az ablak átvehesse. */
export function stashTenantEntryLink(link) {
    try {
        sessionStorage.setItem(LINK_KEY, JSON.stringify(link));
    } catch (e) {
        // tiltott tárhely: a link belépés nélkül nyílik meg
    }
}

/** A megjegyzett link kivétele (egyszer). */
export function takeTenantEntryLink() {
    try {
        const raw = sessionStorage.getItem(LINK_KEY);
        sessionStorage.removeItem(LINK_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
}

/** Belépés egy intézménybe, igény szerint az írással együtt. */
export function requestEntry(tenantId, withWrite = false) {
    return ask({type: 'enter', tenantId, withWrite});
}
